import App from './App.svelte';
import 'appwrite';
import {AppWriteKeys} from './scripts/appWrite/appWriteKeys';

// Used for compatibility with a <script> imported appwrite installation
//const AppWrite = require('node-appwrite');  
const AppWrite = new window.Appwrite();  

// window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }

AppWrite
  .setEndpoint(AppWriteKeys.endpoint)
  .setProject(AppWriteKeys.projectId)
;

const app = new App({
	target: document.body,
	props: {
		appName: 'FSE companion',
		AppWrite: AppWrite
	}
});

export default app;